import { createFileRoute } from '@tanstack/react-router'
import { SiteInspectionEditorPage } from '@/features/site-inspections/editor'

export const Route = createFileRoute(
  '/site-inspections_/$siteInspectionId/edit',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { siteInspectionId } = Route.useParams()
  return <SiteInspectionEditorPage siteInspectionId={siteInspectionId} />
}
